import { ENDPOINTS } from "@/api/endpoints";
import { apiClient } from "@/lib/client";

import { useMutation, UseMutationOptions } from "@tanstack/react-query";

export const generateInsight = async (
  jobId: string,
  startDate: string,
  endDate: string
): Promise<any> => {
  const response = await apiClient
    .post(ENDPOINTS.GENERATE_INSIGHTS(jobId, startDate, endDate), {
      timeout: 600000, // generation is synchronous on the backend; match nginx proxy_read_timeout
    })
    .json<any>();
  return response;
};

export const useGenerateInsightMutation = (
  options?: UseMutationOptions<
    any,
    Error,
    { jobId: string; startDate: string; endDate: string },
    unknown
  >
) => {
  return useMutation({
    mutationFn: ({ jobId, startDate, endDate }) =>
      generateInsight(jobId, startDate, endDate),
    ...options,
  });
};
